export default __webpack_public_path__ + "5c277be50307f536671d8e556d6d3029.svg";